import React, { useState, useEffect, useRef } from "react";
import './grid.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

function Grid(props) {
    const data = props.data;
    const [showAll, setShowAll] = useState(false);
    const displayData = showAll ? data : data.slice(0, 6);

    const gridContainerRef = useRef(null);

    //console.log(gridContainerRef);

    useEffect(() => {
        if (!showAll && gridContainerRef.current) {
            const topOfGrid = gridContainerRef.current.offsetTop;
            if (window.pageYOffset !== 0) {
                window.scrollTo({
                    top: topOfGrid - 210,
                    behavior: "smooth"
                });
            }
        }
    }, [showAll, gridContainerRef]);



    const headerSize = {
        fontSize: '20px'
    };

    const parSize = {
        fontSize: '15px',
        color: '#0583a0'

    };

    function handleGridItemClick(event, urlz, titlez) {
        const notebookUrl = urlz;
        const wtitle = `${titlez} - Code`;

        const notebookWindow = window.open(notebookUrl, wtitle, 'height=800,width=1200');

        const timer = setInterval(() => {
            if (notebookWindow && notebookWindow.document) {
                clearInterval(timer);
                notebookWindow.document.title = wtitle;
            }
        }, 100);

        const setTitle = () => {
            notebookWindow.document.title = wtitle;
        };

        setTimeout(setTitle, 20);

        notebookWindow.addEventListener('beforeunload', () => {
            notebookWindow.document.title = wtitle;
        });

        notebookWindow.addEventListener('load', () => {
            notebookWindow.document.title = wtitle;
        });
    }


    function handleReadme(event, readmez, titlez) {
        event.stopPropagation();

        const nbreadme = readmez;
        const nbreadmeTitle = `${titlez} - Readme`;

        const nbreadmeWindow = window.open(nbreadme, nbreadmeTitle, 'height=800,width=1200');

        const timer = setInterval(() => {
            if (nbreadmeWindow && nbreadmeWindow.document) {
                clearInterval(timer);
                nbreadmeWindow.document.title = nbreadmeTitle;
            }
        }, 100);

        const setTitle = () => {
            nbreadmeWindow.document.title = nbreadmeTitle;
        };

        setTimeout(setTitle, 20);

        nbreadmeWindow.addEventListener('load', () => {
            nbreadmeWindow.document.title = nbreadmeTitle;
        });

        nbreadmeWindow.addEventListener('beforeunload', () => {
            nbreadmeWindow.document.title = nbreadmeTitle;
        });
    }

    //localstorage??



    return (
        <div className="grid-container-wrapper">
            <div className="grid-container" ref={gridContainerRef}>
                {displayData.map(item => (
                    <div className="grid-item" key={item.id} onClick={(event) => handleGridItemClick(event, item.url, item.title)}>
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                        <br />
                        <a style={headerSize}>{item.title}
                            <br />
                            <p style={parSize}> {item.info} </p>
                        </a>
                        <div className="button-wrapper" key={item.id}>
                            <button className="grid-button-box" onClick={(event) => handleReadme(event, item.readme, item.title)}>Readme</button>
                        </div>
                    </div>
                ))}
            </div>
            <div className="grid-button-container">
                {!showAll && (
                    <button className="buttonSM" onClick={() => setShowAll(true)}>Show More</button>
                )}
                {showAll && (
                    <button className="buttonSL" onClick={() => setShowAll(false)}>Show Less</button>
                )}
            </div>
        </div>
    );
}

export default Grid;
